import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepsContent: {
    background: "white",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxHeight: "70vh",
    overflowY: "auto",
  },
  stepIcon: {
    color: theme.palette.primary.main,
    "&$activeStepIcon": {
      color: theme.palette.primary.main,
    },
    "&$completedStepIcon": {
      color: theme.palette.grey[500],
    },
  },
  activeStepIcon: {},
  completedStepIcon: {},
  stepLabel: {
    fontSize: "1rem",
    color: theme.palette.text.primary,
    "&.MuiStepLabel-completed": {
      color: theme.palette.grey[500],
    },
  },
  activeStepLabel: {
    fontSize: 16,
  },
}));
